module.exports = __webpack_public_path__ + "img/message.9c6077df.svg";